import { instance as axiosInstance, withHeaders } from 'core/util';
import { getDefaultHeaders } from 'core/util/other';
import { AttributeAssociationItem } from '../../../pages/edge-definitions/edge-definition-helper';

export const getDictionaries = async (token: string): Promise<any[]> => {
    const headers = getDefaultHeaders(token);
    if (headers.BIQ_SDZ_NAME) {
        const response = await axiosInstance().get(
            '/metadata/dictionary',
            withHeaders(headers)
        );

        return response.data;
    } else return [];
};

export const initializePropertiesList = (
    properties: any
): AttributeAssociationItem[] => {
    if (!properties) return [];

    return Object.keys(properties).map((key) => ({
        id: crypto.randomUUID(),
        attributeAssociation: {
            leftSideValue: key,
            rightSideValue: properties[key],
        },
        leftSideError: false,
        leftSideErrorMessage: '',
        rightSideError: false,
        rightSideErrorMessage: '',
    }));
};
